export default "__VITE_ASSET__NWjkWq9C__"